import createFetchedSlice from 'Stores/hors/fetchedSlice';
const higherOrderReducers = {
	createFetchedSlice
}

export default higherOrderReducers;